import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import styles from './Toggle.module.scss'

const cx = classNames.bind(styles)

const Toggle = ({ id, checked, handleToggle, label, disabled, tooltipText }) => {
  const showTooltip = !!tooltipText

  const toggle = (
    <div className={cx('toggle-container', { disabled, 'has-tooltip': showTooltip })}>
      <input
        className={cx('checkbox')}
        id={id}
        type="checkbox"
        checked={checked}
        onChange={handleToggle}
        data-testid={id}
        disabled={disabled}
      />
      <label
        className={cx('toggle', {
          'toggle-selected': checked,
        })}
        htmlFor={id}
      >
        <span className={cx('toggle-button')} />
      </label>
      <span
        className={cx('label', {
          'label-selected': checked,
        })}
        onClick={!disabled ? handleToggle : () => {}}
        data-testid="label"
      >
        {label}
      </span>
    </div>
  )

  if (showTooltip) {
    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`${id}-tooltip`} className={cx('toggle-tooltip')}>
            <div>{tooltipText}</div>
          </Tooltip>
        }
      >
        <div className={cx('toggle-wrapper')}>{toggle}</div>
      </OverlayTrigger>
    )
  }

  return toggle
}

Toggle.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  handleToggle: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  tooltipText: PropTypes.string,
}

Toggle.defaultProps = {
  disabled: false,
  tooltipText: null,
}

export { Toggle }
